// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class OrganisationResource extends Resource {
    basePath: string = 'clients/clients/organisation/';

    objectPath: string = 'clients/clients/organisation/{ident}/';
}
